export const LIVE_SCREENSHOTS_WSC_INSTALLED_ALL = "all";
export const LIVE_SCREENSHOTS_WSC_INSTALLED_YES = "yes";
export const LIVE_SCREENSHOTS_WSC_INSTALLED_NO = "no";

export const LIVE_SCREENSHOTS_WSC_INSTALLED_DEFAULT =
    LIVE_SCREENSHOTS_WSC_INSTALLED_ALL;

/**
 * @param {string|null|undefined} value
 * @returns {typeof LIVE_SCREENSHOTS_WSC_INSTALLED_ALL | typeof LIVE_SCREENSHOTS_WSC_INSTALLED_YES | typeof LIVE_SCREENSHOTS_WSC_INSTALLED_NO}
 */
export function resolveLiveScreenshotsWscInstalledFilter(value) {
    if (value === LIVE_SCREENSHOTS_WSC_INSTALLED_YES) {
        return LIVE_SCREENSHOTS_WSC_INSTALLED_YES;
    }

    if (value === LIVE_SCREENSHOTS_WSC_INSTALLED_NO) {
        return LIVE_SCREENSHOTS_WSC_INSTALLED_NO;
    }

    return LIVE_SCREENSHOTS_WSC_INSTALLED_ALL;
}

export const LIVE_SCREENSHOTS_WSC_INSTALLED_OPTIONS = [
    { label: "All", value: LIVE_SCREENSHOTS_WSC_INSTALLED_ALL },
    { label: "Yes", value: LIVE_SCREENSHOTS_WSC_INSTALLED_YES },
    { label: "No", value: LIVE_SCREENSHOTS_WSC_INSTALLED_NO },
];

/**
 * Whether WSC is installed for a live-screenshot card.
 * Uses `wsc_installed` from the team-dashboard payload (available to all viewers).
 *
 * @param {{ wsc_installed?: boolean }} screenshot
 * @returns {boolean}
 */
export function resolveLiveScreenshotWscInstalled(screenshot) {
    return Boolean(screenshot?.wsc_installed);
}

/**
 * Filter live screenshot cards by WSC Installed All/Yes/No.
 *
 * @param {Array<{ wsc_installed?: boolean }>} screenshots
 * @param {string} wscInstalledFilter
 * @returns {Array}
 */
export function filterLiveScreenshotsByWscInstalled(
    screenshots,
    wscInstalledFilter,
) {
    const list = Array.isArray(screenshots) ? screenshots : [];

    if (
        wscInstalledFilter === LIVE_SCREENSHOTS_WSC_INSTALLED_ALL ||
        wscInstalledFilter == null ||
        wscInstalledFilter === ""
    ) {
        return list;
    }

    const want_installed =
        wscInstalledFilter === LIVE_SCREENSHOTS_WSC_INSTALLED_YES;

    return list.filter((screenshot) => {
        const installed = resolveLiveScreenshotWscInstalled(screenshot);

        return want_installed ? installed : !installed;
    });
}
